<template>
	<div class="integration">
		<div class="breadcrumb">奖品配置
			<el-button class="right_f" type="primary" @click="changeIntegration">更新奖品</el-button>
		</div>

		<div class="com-list">
			<!-- 奖品列表 -->
			<el-table :data="list">
				<el-table-column prop="position" label="替换序号" align='center' width="120">
				</el-table-column>
				<el-table-column prop="prizeName" label="奖品名称" align='center'>
				</el-table-column>
				<el-table-column inline-template label="图片" align='center'>
					<div>
						<img :src="row.imgUrl" style="display:inline-block;width:150px;margin-top:5px;">
					</div>
				</el-table-column>
				<el-table-column prop="prizeCount" label="数量" align='center'>
				</el-table-column>
				<el-table-column prop="probability" label="中奖概率" align='center'>
				</el-table-column>
				<el-table-column inline-template label="兑换时间" align='center'>
					<div>
						<div v-if="row.startTime && row.endTime">{{row.startTime}} - {{row.endTime}}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="最近操作记录" align='center' width="200">
					<div>
						<div>{{row.operator}}</div>
						<div v-if="row.startTime && row.endTime">{{row.operateTime}}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="操作">
					<span>
						<el-button class="option" type="text" @click="newIntegration(0,row)" v-if="!row.prizeName">添加</el-button>
						<el-button class="option" type="text" @click="toDet(row.position)" v-if="row.prizeName">详情</el-button>
						<el-button class="option" type="text" @click="newIntegration(1,row)" v-if="row.prizeName && !row.hasReplacePrize">编辑</el-button>
					</span>
				</el-table-column>
			</el-table>
		</div>

		<div class="breadcrumb">活动替换
			<el-button type="primary" @click="toDownline(2)" style="margin-left: 15px;">已下线奖品</el-button>
			<el-button type="primary" @click="toDownline(0)" style="margin-left: 15px;">待上线奖品</el-button>
			<el-button class="right_f" type="primary" @click="newIntegration(2)">添加替换奖品</el-button>
		</div>
		<div class="com-list" style="margin-bottom:20px;">
			<!-- 替换列表 -->
			<el-table :data="list_change">
				<el-table-column prop="position" label="替换序号" align='center' width="120">
				</el-table-column>
				<el-table-column prop="prizeName" label="奖品名称" align='center'>
				</el-table-column>
				<el-table-column inline-template label="图片" align='center'>
					<div>
						<img :src="row.imgUrl" style="display:inline-block;width:150px;margin-top:5px;">
					</div>
				</el-table-column>
				<el-table-column prop="prizeCount" label="数量" align='center'>
				</el-table-column>
				<el-table-column label="替换时间" inline-template align='center'>
					<div v-if="row.replaceStartTime && row.replaceEndTime">
						<div>{{row.replaceStartTime}} - {{row.replaceEndTime}}</div>
					</div>
				</el-table-column>
				<el-table-column label="兑换时间" inline-template align='center'>
					<div>
						<div v-if="row.startTime && row.endTime">{{row.startTime}} - {{row.endTime}}</div>
					</div>
				</el-table-column>
				<el-table-column prop="applicableCampus" label="学校" align='center'>
				</el-table-column>
				<el-table-column inline-template label="最近操作记录" align='center' width="200">
					<div>
						<div>{{row.operator}}</div>
						<div>{{row.operateTime}}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="操作">
					<span>
						<el-button class="option" type="text" @click="toChangeDet(row)" v-if="row.id">详情</el-button>
						<el-button class="option" type="text" @click="unPublish(row)">下线</el-button>
					</span>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import { mapState, mapActions } from "vuex";

	export default {
		data() {
			return {
				list: [],
				list_change: [],
				canUpdate: true,
				needUpdate: this.$util.getUrlParam("needUpdate") || "false",
				operatorId: this.$store.state.user.userId
			};
		},
		mounted() {
			//默认请求奖品替换列表
			this.getList();
			if (this.$util.getUrlParam("isFirst") !== "1") {
				//从其他模块进入，从接口请求奖品列表；
				this.getPrizeList();
			} else {
				//从积分模块其他页面回来，是否需要请求列表
				if (this.needUpdate == "true") {
					this.getPrizeList();
				} else {
					//从本地获取奖品列表
					let list = JSON.parse(this.$util.getStore("prizeList"));
					this.handleData(list || [], false);
				}
			}
		},
		methods: {
			//获取奖品配置列表
			getPrizeList() {
				let url = this.$util.domain + "/adminapi/v2/rounddisk/origin/list";

				//请求列表的ajax；
				this.$http({
					url,
					method: "GET",
					headers: {
						operatorId: this.operatorId + ""
					}
				}).then(response => {
					//请求成功，重置列表数组；
					this.list = [];

					if (response.data.error === 10000) {
						let dataList = response.data.data;

						//对请求数据进行遍历格式化，存储到本地并赋值给列表数组；
						this.handleData(dataList, true);
					} else {
						this.$util.errorMsg(response.data.message);
					}
				});
			},
			//获取奖品替换列表
			getList() {
				let url = this.$util.domain + "/adminapi/v2/rounddisk/replace/list";

				//请求列表的ajax；
				this.$http({
					url,
					method: "GET",
					headers: {
						operatorId: this.operatorId + ""
					},
					params: {
						type: 1 //0：待上架；1：上架；2，已下架；
					}
				}).then(response => {
					//请求成功，重置列表数组；
					this.list_change = [];

					if (response.data.error === 10000) {
						let dataList = response.data.data;

						//对请求数据进行遍历格式化，并赋值给列表数组；
						dataList.forEach(item => {
							this.list_change.push({
								id: item.id,
								position: item.position,
								prizeName: item.prizeName,
								imgUrl: item.imgUrl,
								prizeCount: item.prizeCount == -1 ? "无限" : item.prizeCount,
								operator: item.operator,
								startTime: item.startTime
									? new Date(item.startTime).format("yyyy.MM.dd")
									: "",
								endTime: item.endTime
									? new Date(item.endTime).format("yyyy.MM.dd")
									: "",
								replaceStartTime: new Date(item.replaceStartTime).format(
									"yyyy.MM.dd"
								),
								replaceEndTime: new Date(item.replaceEndTime).format(
									"yyyy.MM.dd"
								),
								applicableCampus: item.applicableCampus == 0 ? "全部" : "部分",
								operateTime: item.operateTime
									? new Date(item.operateTime).format("yyyy.MM.dd hh:mm")
									: ""
							});
						});
					} else {
						this.$util.errorMsg(response.data.message);
					}
				});
			},
			//获取默认数组
			getDefaultData() {
				for (let i = 0; i < 8; i++) {
					this.list.push({
						id: 0,
						position: i + 1,
						prizeName: "",
						imgUrl: "",
						prizeCount: "",
						probability: "",
						definePrizeUrl: "",
						prizeUrl: "",
						adExposingCodes: "",
						defineText: "",
						redeemText: "",
						operator: "",
						hasReplacePrize: "",
						isInfinite: "",
						isRedeem: "",
						isAuto: "",
						startTime: "",
						endTime: "",
						fileUrl: "",
						drawHitCount: "",
						operateTime: ""
					});
				}
			},
			//接口数据处理;needSet：true，需要存储本地；false，不需要存储本地；
			handleData(list, needSet) {
				this.list = [];
				if (needSet) {
					this.$util.setStore("updateList", []);

					if (list && list.length) {
						//从其他模块进入积分模块，将数据存储至本地，并建立本地的空数组表示尚未发生更新；
						list.forEach(item => {
							item.fileUrl = "";
							item.isRedeem = item.isRedeem + "";
						});
						this.$util.setStore("prizeList", list);
					} else {
						this.getDefaultData();
						this.$util.setStore("prizeList", this.list);
					}
				}

				list.forEach(item => {
					this.list.push({
						id: item.id,
						position: item.position,
						prizeName: item.prizeName,
						imgUrl: item.imgUrl,
						prizeCount: item.prizeCount == -1 ? "无限" : item.prizeCount,
						probability: item.probability ? item.probability / 100 + "%" : "",
						definePrizeUrl: item.definePrizeUrl,
						prizeUrl: item.prizeUrl,
						adExposingCodes: item.adExposingCodes,
						drawHitCount: item.drawHitCount,
						isRedeem: item.isRedeem + "",
						defineText: item.defineText,
						redeemText: item.redeemText || '',
						hasReplacePrize: item.hasReplacePrize,
						operator: item.operator,
						startTime: item.startTime
							? new Date(item.startTime).format("yyyy.MM.dd")
							: "",
						endTime: item.endTime
							? new Date(item.endTime).format("yyyy.MM.dd")
							: "",
						operateTime: item.operateTime
							? new Date(item.operateTime).format("yyyy.MM.dd hh:mm")
							: ""
					});
				});
			},
			//奖品列表更新
			changeIntegration() {
				if (!this.canUpdate) {
					return;
				}

				this.canUpdate = false;
				let updateList = JSON.parse(this.$util.getStore("updateList"));
				let dataList = JSON.parse(this.$util.getStore("prizeList"));

				if (updateList.length == 0) {
					//奖品列表没有更新；
					this.$util.errorMsg("奖品信息均未发生改变，无法进行更新");

					return;
				}

				let hasEnough = true,
					list = [],
					percentage = 0;
				dataList.forEach(item => {
					percentage = percentage + item.probability;
					if (!item.prizeName) {
						hasEnough = false;
					}
				});

				if (!hasEnough) {
					//奖品列表没有更新；
					this.$util.errorMsg("奖品数量不足8个，请完善");

					return;
				}

				if (percentage != 10000) {
					//奖品列表没有更新；
					this.$util.errorMsg("中奖概率总和不是100%，请检查");

					return;
				}

				updateList.forEach(item => {
					delete dataList[item].operator;
					delete dataList[item].operateTime;
					delete dataList[item].hasReplacePrize;
					dataList[item].isRedeem = dataList[item].isRedeem * 1;
					list.push(dataList[item]);
				});

				//可以进行更新
				let url = this.$util.domain + "/adminapi/v2/rounddisk/origin/save";
				this.$http({
					url,
					method: "POST",
					headers: {
						operatorId: this.operatorId + ""
					},
					body: JSON.stringify(list)
				}).then(response => {
					this.canUpdate = true;
					if (response.data.error == 10000) {
						//更新成功
						this.getPrizeList();
						this.$util.successMsg("更新奖品成功");
					} else {
						//更新失败
						this.$util.errorMsg("更新奖品失败");
					}
				});
			},
			//添加奖品配置
			newIntegration(actionType, item) {
				//actionType:操作类型：0，新增；1，编辑；2，替换；
				if (actionType == 0) {
					location.href =
						"/#/yunying/integration/newIntegration?id=0&isEdit=false&position=" +
						item.position;
				} else if (actionType == 1) {
					location.href =
						"/#/yunying/integration/newIntegration?id=" +
						item.id +
						"&isEdit=true&position=" +
						item.position;
				} else if (actionType == 2) {
					location.href = "/#/yunying/integration/changeIntegration";
				}
			},
			//查看详情
			toDet(position) {
				location.href =
					"/#/yunying/integration/integrationDet?position=" + position;
			},
			//替换详情
			toChangeDet(row) {
				location.href =
					"/#/yunying/integration/inteChangeDet?isReplace=1&id=" + row.id;
			},
			//跳转已下线奖品列表
			toDownline(online) {
				location.href = "/#/yunying/integration/downline?online=" + online;
			},
			//下线
			unPublish(row) {
				//弹出确认是否下线弹出框
				this.$confirm(`是否要下线${row.prizeName}`, "提示", {
					confirmButtonText: "是",
					cancelButtonText: "否",
					type: "warning"
				}).then(() => {
					//选择确定，发送ajax请求，下线奖品;
					let url = this.$util.domain + "/adminapi/v2/rounddisk/replace/offline";

					this.$http({
						url,
						method: "POST",
						headers: {
							operatorId: this.operatorId + ""
						},
						body: JSON.stringify({
							id: row.id * 1
						})
					})
						.then(response => {
							if (response.data.error === 10000) {
								this.$util.successMsg("下线成功");
								this.getPrizeList();
								this.getList();
							} else {
								this.$util.errorMsg(response.data.message);
							}
						})
						.catch(response => {
							//选择否，关闭弹框；
						});
				});
			}
		}
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// integration.vue?49f6680e